
export function getBrowserLocale() {
  const brLocale = window.navigator.language;
  let dtLocale = brLocale;
  if (dtLocale === 'ja' || dtLocale === 'ja-JP') {
   dtLocale = 'ja';
  }
 return dtLocale;
}


